export const TABLE_REACTION_IDS = [
    'banana',
    'beer',
    'bomb',
    'bottle',
    'coin',
    'confused',
    'crown',
    'eyes',
    'faceInClouds',
    'fish',
    'ghost',
    'heartFingers',
    'heartHands',
    'heart',
    'horns',
    'lyingFace',
    'moneyFace',
    'monkeyFace',
    'monkeyHands',
    'penguin',
    'poop',
    'rofl',
    'skull',
    'starStruck',
    'turtle',
    'worm',
    'zanyFace',
    'zzz'
] as const;

export type TableReactionId = typeof TABLE_REACTION_IDS[number];

export interface ITableReactionEvent {
    reactionEventId: string;
    roomId: string;
    sequence: number;
    serverTime: string;
    reactionId: TableReactionId;
    sourceUserId: string;
    sourceUsername: string;
    sourceAvatarUrl?: string;
    sourceSeatIndex?: number;
    targetUserId: string;
    targetUsername: string;
    targetAvatarUrl?: string;
    targetSeatIndex?: number;
}

export const TABLE_REACTION_REJECT_REASONS = [
    'invalid_reaction',
    'source_not_seated',
    'source_not_active',
    'target_not_seated',
    'self_target_not_allowed',
    'rate_limited',
    'room_not_available'
] as const;

export type TableReactionRejectedReason = typeof TABLE_REACTION_REJECT_REASONS[number];

export interface ITableReactionRejected {
    roomId: string;
    reason: TableReactionRejectedReason;
    retryAfterMs?: number;
}
